import {Injectable} from '@angular/core';
import {AuthConfig, OAuthService} from 'angular-oauth2-oidc';

import {environment} from '../environments/environment';

const clientId = 'dashboard';
const scope = 'openid offline_access api profile roles';
const oidc = false;

@Injectable()
export class OAuthConfig {

  constructor(private oAuthService: OAuthService) {
  }

  load(): Promise<object> {
    let url: string;

    const oAuthConfig: AuthConfig = {
      clientId: clientId,
      scope: scope,
      oidc: oidc,
      issuer: environment.issuer,
      requireHttps: environment.requireHttps,
      postLogoutRedirectUri: environment.postLogoutRedirectUri
    };

    this.oAuthService.configure(oAuthConfig);

    // Defines the storage.
    this.oAuthService.setStorage(localStorage);

    // Loads Discovery Document.
    return this.oAuthService.loadDiscoveryDocument(`${environment.issuer}/.well-known/openid-configuration`);
  }

}
